module.exports = __webpack_public_path__ + "assets/floor1.png?222c70159a95aad40488253f3eb2eead";